// extracted by mini-css-extract-plugin
export var searchHeader = "_96-0";
export var searchHeaderDark = "_96-1";